import Vue from 'vue';
import Cookies from 'js-cookie';
import VueRouter from 'vue-router';

import AuthLayout from '@/views/layout/auth';
import AdminLayout from '@/views/layout/admin';
import PrintLayout from '@/views/layout/print';
import PublicLayout from '@/views/layout/public';

import AuthLoginPage from '@/views/pages/auth/login';
import AuthRegisterPage from '@/views/pages/auth/register';
import AuthRecoverPage from '@/views/pages/auth/recover';
import AuthResetPage from '@/views/pages/auth/reset';

import AdminHomePage from '@/views/pages/admin/home';
import AdminDashboardPage from '@/views/pages/admin/dashboard';

import AdminRepairList from '@/views/pages/admin/repairs/list';
import AdminRepairNew from '@/views/pages/admin/repairs/new';
import AdminRepairEdit from '@/views/pages/admin/repairs/edit';

import AdminStockList from '@/views/pages/admin/stocks/list';
import AdminStockNew from '@/views/pages/admin/stocks/new';
import AdminStockEdit from '@/views/pages/admin/stocks/edit';

import AdminCustomBillList from '@/views/pages/admin/custom-bills/list';
import AdminCustomBillNew from '@/views/pages/admin/custom-bills/new';
import AdminCustomBillEdit from '@/views/pages/admin/custom-bills/edit';

import AdminWarehouseList from '@/views/pages/admin/warehouses/list';
import AdminWarehouseNew from '@/views/pages/admin/warehouses/new';
import AdminWarehouseEdit from '@/views/pages/admin/warehouses/edit';

import AdminCategoriesList from '@/views/pages/admin/categories/list';
import AdminCategoriesNew from '@/views/pages/admin/categories/new';
import AdminCategoriesEdit from '@/views/pages/admin/categories/edit';

import AdminSaleList from '@/views/pages/admin/sale-orders/list';
import AdminSaleView from '@/views/pages/admin/sale-orders/view';

import AdminProductsList from '@/views/pages/admin/products/list';
import AdminProductsNew from '@/views/pages/admin/products/new';
import AdminProductsEdit from '@/views/pages/admin/products/edit';

import AdminCustomProductList from '@/views/pages/admin/custom-products/list';
import AdminCustomProductNew from '@/views/pages/admin/custom-products/new';
import AdminCustomProductEdit from '@/views/pages/admin/custom-products/edit';

import AdminUsersList from '@/views/pages/admin/users/list';
import AdminUsersNew from '@/views/pages/admin/users/new';
import AdminUsersEdit from '@/views/pages/admin/users/edit';

import AdminUserRolesList from '@/views/pages/admin/user-roles/list';
import AdminUserRolesNew from '@/views/pages/admin/user-roles/new';
import AdminUserRolesEdit from '@/views/pages/admin/user-roles/edit';

import AdminSettingsIndex from '@/views/pages/admin/settings';
import AdminSettingsGeneral from '@/views/pages/admin/settings/general';
import AdminSettingsAppearance from '@/views/pages/admin/settings/appearance';
import AdminSettingsLocalization from '@/views/pages/admin/settings/localization';
import AdminSettingsAuthentication from '@/views/pages/admin/settings/authentication';
import AdminSettingsOutgoingMail from '@/views/pages/admin/settings/outgoing-mail';
import AdminSettingsCaptcha from '@/views/pages/admin/settings/captcha';
import AdminSettingsCurrency from '@/views/pages/admin/settings/currency';
import AdminSettingsTax from '@/views/pages/admin/settings/tax';
import AdminSettingsTerms from '@/views/pages/admin/settings/terms';
import AdminSettingsPrinter from '@/views/pages/admin/settings/printer';
import AdminSettingsPosSetup from '@/views/pages/admin/settings/pos-setup';
import AdminSettingsEmbedAble from '@/views/pages/admin/settings/embed-able';

import AdminBackupAndRestore from '@/views/pages/admin/backup/index';

import AdminLanguagesList from '@/views/pages/admin/language/list';
import AdminLanguagesNew from '@/views/pages/admin/language/new';
import AdminLanguagesEdit from '@/views/pages/admin/language/edit';

import AccountPage from '@/views/pages/account/account';

import AdminReport from '@/views/pages/admin/report';
import AdminStockAlerts from '@/views/pages/admin/out-of-stock';

import PublicPos from '@/views/pages/public/pos';
import PublicRepairNew from '@/views/pages/public/repair-new';
import PublicCustomBill from '@/views/pages/public/custom-bill-new';
import PublicCustomProduct from '@/views/pages/public/custom-product-new';
import PublicIndex from '@/views/pages/public/index';

import PrintRepairOrder from '@/views/pages/print/repair-order';
import PrintSaleOrder from '@/views/pages/print/sale-order';
import PrintCustomBillOrder from '@/views/pages/print/custom-bill';
import PrintCustomProductOrder from '@/views/pages/print/custom-product';
import PrintReportCard from '@/views/pages/print/report-card';
import PrintProductLabel from '@/views/pages/print/product-label';
import RepairEmbedableWidget from '@/views/pages/widgets/repair-track';
import DashboardNotFoundPage from '@/views/pages/admin/error/not-found';
import PageNotFoundPage from '@/views/pages/error/not-found';

Vue.use(VueRouter);

const routes = [
  {
    path: '/repair-track-widget/:key?',
    component: RepairEmbedableWidget,
    meta: { middleware: null, gate: null },
  },
  {
    path: '/t/:key?',
    component: RepairEmbedableWidget,
    meta: { middleware: null, gate: null },
  },
  {
    path: '/auth',
    component: AuthLayout,
    redirect: '/auth/login',
    children: [
      {
        path: 'login',
        component: AuthLoginPage,
        meta: { middleware: 'guest' },
      },
      {
        path: 'register',
        component: AuthRegisterPage,
        meta: { middleware: ['guest', 'register'] },
      },
      {
        path: 'recover',
        component: AuthRecoverPage,
        meta: { middleware: 'guest' },
      },
      {
        path: 'reset/:token',
        component: AuthResetPage,
        meta: { middleware: 'guest' },
      },
    ],
  },
  {
    path: '/print/product-label/:id?/:symbology?/:title?/:price?/:imei?',
    component: PrintProductLabel,
    name: 'print-label',
    meta: { middleware: 'auth', gate: null },
  },
  {
    path: '/print',
    component: PrintLayout,
    meta: { middleware: null, gate: null },
    children: [
      {
        path: 'custom-bill/:uuid',
        component: PrintCustomBillOrder,
        meta: { middleware: null, gate: null },
      },
      {
        path: 'repair/:uuid',
        component: PrintRepairOrder,
        meta: { middleware: null, gate: null },
      },
      {
        path: 'custom-product/:uuid',
        component: PrintCustomProductOrder,
        meta: { middleware: null, gate: null },
      },

      {
        path: 'sale-order/:uuid',
        component: PrintSaleOrder,
        meta: { middleware: null, gate: null },
      },
      {
        path: 'report',
        component: PrintReportCard,
        meta: { middleware: null, gate: null },
      },
    ],
  },
  {
    path: '/qr',
    component: PrintLayout,
    meta: { middleware: null, gate: null },
    children: [
      {
        path: 'b/:uuid',
        component: PrintCustomBillOrder,
        meta: { middleware: null, gate: null },
      },
      {
        path: 'r/:uuid',
        component: PrintRepairOrder,
        meta: { middleware: null, gate: null },
      },
      {
        path: 'p/:uuid',
        component: PrintCustomProductOrder,
        meta: { middleware: null, gate: null },
      },

      {
        path: 's/:uuid',
        component: PrintSaleOrder,
        meta: { middleware: null, gate: null },
      },
    ],
  },

  {
    path: '/',
    component: PublicLayout,
    redirect: '/welcome',
    meta: { middleware: 'auth', gate: null },
    children: [
      {
        path: 'account',
        component: AccountPage,
        meta: { middleware: 'auth', gate: null },
      },

      {
        path: '/repair-booking',
        component: PublicRepairNew,
        meta: { middleware: 'auth', gate: 'add_repairs' },
      },
      {
        path: '/pos',
        component: PublicPos,
        meta: { middleware: 'auth', gate: 'pos_sales' },
      },
      {
        path: '/custom-bill',
        component: PublicCustomBill,
        meta: { middleware: 'auth', gate: 'add_custom_products' },
      },
      {
        path: '/custom-product',
        component: PublicCustomProduct,
        meta: { middleware: 'auth', gate: 'add_custom_bills' },
      },
      {
        path: '/welcome',
        component: PublicIndex,
        meta: { middleware: 'auth' },
      },
    ],
  },
  {
    path: '/admin',
    component: AdminLayout,
    redirect: 'admin/home',
    meta: { middleware: 'auth', gate: null },
    children: [
      {
        path: 'home',
        component: AdminHomePage,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'dashboard',
        component: AdminDashboardPage,
        meta: { middleware: 'auth', gate: 'dashboard_access' },
      },

      {
        path: 'products',
        component: AdminProductsList,
        meta: { middleware: 'auth', gate: 'manage_products' },
      },
      {
        path: 'products/new',
        component: AdminProductsNew,
        meta: { middleware: 'auth', gate: 'manage_products' },
      },
      {
        path: 'products/:id/edit',
        component: AdminProductsEdit,
        meta: { middleware: 'auth', gate: 'manage_products' },
      },

      {
        path: 'custom-products',
        component: AdminCustomProductList,
        meta: { middleware: 'auth', gate: 'manage_custom_products' },
      },
      {
        path: 'custom-products/new',
        component: AdminCustomProductNew,
        meta: { middleware: 'auth', gate: 'add_custom_products' },
      },
      {
        path: 'custom-products/:id/edit',
        component: AdminCustomProductEdit,
        meta: { middleware: 'auth', gate: 'manage_custom_products' },
      },

      {
        path: 'report',
        component: AdminReport,
        meta: { middleware: 'auth', gate: 'report' },
      },
      {
        path: 'out-of-stock',
        component: AdminStockAlerts,
        meta: { middleware: 'auth', gate: 'out_of_stock_alert' },
      },

      {
        path: 'categories',
        component: AdminCategoriesList,
        meta: { middleware: 'auth', gate: 'manage_categories' },
      },
      {
        path: 'categories/new',
        component: AdminCategoriesNew,
        meta: { middleware: 'auth', gate: 'manage_categories' },
      },
      {
        path: 'categories/:id/edit',
        component: AdminCategoriesEdit,
        meta: { middleware: 'auth', gate: 'manage_categories' },
      },
      {
        path: 'repairs',
        component: AdminRepairList,
        meta: { middleware: 'auth', gate: 'manage_repairs' },
      },
      {
        path: 'repairs/new',
        component: AdminRepairNew,
        meta: { middleware: 'auth', gate: 'add_repairs' },
      },
      {
        path: 'repairs/:id/edit',
        component: AdminRepairEdit,
        meta: { middleware: 'auth', gate: 'manage_repairs' },
      },

      {
        path: 'custom-bills',
        component: AdminCustomBillList,
        meta: { middleware: 'auth', gate: 'manage_custom_bills' },
      },
      {
        path: 'custom-bills/new',
        component: AdminCustomBillNew,
        meta: { middleware: 'auth', gate: 'add_custom_bills' },
      },
      {
        path: 'custom-bills/:id/edit',
        component: AdminCustomBillEdit,
        meta: { middleware: 'auth', gate: 'manage_custom_bills' },
      },

      {
        path: 'stocks',
        component: AdminStockList,
        meta: { middleware: 'auth', gate: 'manage_stocks' },
      },
      {
        path: 'stocks/new',
        component: AdminStockNew,
        meta: { middleware: 'auth', gate: 'manage_stocks' },
      },
      {
        path: 'stocks/:id/edit',
        component: AdminStockEdit,
        meta: { middleware: 'auth', gate: 'manage_stocks' },
      },

      {
        path: 'warehouses',
        component: AdminWarehouseList,
        meta: { middleware: 'auth', gate: 'manage_warehouses' },
      },
      {
        path: 'warehouses/new',
        component: AdminWarehouseNew,
        meta: { middleware: 'auth', gate: 'manage_warehouses' },
      },
      {
        path: 'warehouses/:id/edit',
        component: AdminWarehouseEdit,
        meta: { middleware: 'auth', gate: 'manage_warehouses' },
      },
      {
        path: 'sale-orders',
        component: AdminSaleList,
        meta: { middleware: 'auth', gate: 'manage_sales' },
      },
      {
        path: 'sale-orders/:uuid',
        component: AdminSaleView,
        meta: { middleware: 'auth', gate: 'manage_sales' },
      },
      {
        path: 'users',
        component: AdminUsersList,
        meta: { middleware: 'auth', gate: 'manage_users' },
      },
      {
        path: 'users/new',
        component: AdminUsersNew,
        meta: { middleware: 'auth', gate: 'manage_users' },
      },
      {
        path: 'users/:id/edit',
        component: AdminUsersEdit,
        meta: { middleware: 'auth', gate: 'manage_users' },
      },

      {
        path: 'user-roles',
        component: AdminUserRolesList,
        meta: { middleware: 'auth', gate: 'manage_user_roles' },
      },
      {
        path: 'user-roles/new',
        component: AdminUserRolesNew,
        meta: { middleware: 'auth', gate: 'manage_user_roles' },
      },
      {
        path: 'user-roles/:id/edit',
        component: AdminUserRolesEdit,
        meta: { middleware: 'auth', gate: 'manage_user_roles' },
      },
      {
        path: 'settings',
        component: AdminSettingsIndex,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'settings/general',
        component: AdminSettingsGeneral,
        meta: { middleware: 'auth', gate: 'general_configuration' },
      },

      {
        path: 'settings/appearance',
        component: AdminSettingsAppearance,
        meta: { middleware: 'auth', gate: 'appearance_configuration' },
      },
      {
        path: 'settings/localization',
        component: AdminSettingsLocalization,
        meta: { middleware: 'auth', gate: 'localization_configuration' },
      },
      {
        path: 'settings/authentication',
        component: AdminSettingsAuthentication,
        meta: { middleware: 'auth', gate: 'authentication_configuration' },
      },
      {
        path: 'settings/outgoing-mail',
        component: AdminSettingsOutgoingMail,
        meta: { middleware: 'auth', gate: 'outgoing_mail_configuration' },
      },
      {
        path: 'settings/captcha',
        component: AdminSettingsCaptcha,
        meta: { middleware: 'auth', gate: 'captcha_configuration' },
      },
      {
        path: 'settings/currency',
        component: AdminSettingsCurrency,
        meta: { middleware: 'auth', gate: 'currency_configuration' },
      },
      {
        path: 'settings/tax',
        component: AdminSettingsTax,
        meta: { middleware: 'auth', gate: 'tax_configuration' },
      },
      {
        path: 'settings/terms',
        component: AdminSettingsTerms,
        meta: { middleware: 'auth', gate: 'terms_configuration' },
      },
      {
        path: 'settings/printer',
        component: AdminSettingsPrinter,
        meta: { middleware: 'auth', gate: 'printer_configuration' },
      },
      {
        path: 'settings/pos-setup',
        component: AdminSettingsPosSetup,
        meta: { middleware: 'auth', gate: 'pos_configuration' },
      },
      {
        path: 'settings/embed-able-code',
        component: AdminSettingsEmbedAble,
        meta: { middleware: 'auth', gate: null },
      },
      {
        path: 'backup',
        component: AdminBackupAndRestore,
        meta: { middleware: 'auth', gate: 'database_backup' },
      },
      {
        path: 'languages',
        component: AdminLanguagesList,
        meta: { middleware: 'auth', gate: 'manage_translations' },
      },
      {
        path: 'languages/new',
        component: AdminLanguagesNew,
        meta: { middleware: 'auth', gate: 'manage_translations' },
      },
      {
        path: 'languages/:id/edit',
        component: AdminLanguagesEdit,
        meta: { middleware: 'auth', gate: 'manage_translations' },
      },

      {
        path: '*',
        component: DashboardNotFoundPage,
        meta: { middleware: 'auth', gate: null },
      },
    ],
  },

  { path: '*', component: PageNotFoundPage },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeResolve((to, from, next) => {
  if (to.meta.middleware) {
    if (to.meta.middleware.includes('auth') && !localStorage.getItem('token')) {
      Cookies.set('intended_url', to.path);
      next('/auth/login');
    } else if (to.meta.middleware.includes('register') && !window.app.register) {
      next('/auth/login');
    } else if (localStorage.getItem('token') && to.meta.middleware.includes('guest')) {
      next();
    } else if (to.meta.middleware.includes('auth') && localStorage.getItem('token')) {
      axios.post(route('auth.check'), { gate: to.meta.gate }).then((response) => {
        if (!response.data.authorized) {
          Cookies.set('intended_url', to.path);
          next('/auth/login');
        } else if (!to.meta.gate) {
          next();
        } else if (response.data.gate_pass && response.data.admin_access) {
          next();
        } else {
          window.location.href = window.app.url + '/';
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
